import axios from 'axios';

export interface ContentGap {
  question_id: string;
  question_text: string;
  gap_type: string;
  gap_importance: 'high' | 'medium' | 'low';
  suggested_content: string;
  is_answered_in_content: boolean;
}

export interface AnalysisResult {
  summary: {
    total_questions: number;
    answered: number;
    unanswered: number;
    critical_gaps: string[];
  };
  questions: Array<{
    question_id: number;
    question: string;
    is_answered: boolean;
    answer_quote: string | null;
    gap_type: string;
    importance: string;
    suggested_content: string;
  }>;
}

class PAAAnalysisService {
  private baseUrl = '/api/paa-analysis';

  async analyzeSingle(urlId: string): Promise<{ success: boolean; data?: AnalysisResult; error?: string }> {
    try {
      const response = await axios.post(`${this.baseUrl}/analyze-single`, { urlId });
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to analyze content',
      };
    }
  }

  async analyzeBatch(websiteId: string, limit: number = 50): Promise<{ success: boolean; batchId?: string; urlCount?: number; status?: string; error?: string }> {
    try {
      const response = await axios.post(`${this.baseUrl}/analyze-batch`, { websiteId, limit });
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to start batch analysis',
      };
    }
  }

  async getGaps(urlId: string): Promise<{ success: boolean; data?: any; error?: string }> {
    try {
      const response = await axios.get(`${this.baseUrl}/gaps/${urlId}`);
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get content gaps',
      };
    }
  }
}

export const paaAnalysisService = new PAAAnalysisService();